// src/constants/currency.js

export const CURRENCIES = [
  { code: "AED", name: "UAE Dirham",                     symbol: "د.إ"  },
  { code: "ANG", name: "Netherlands Antillean Guilder",  symbol: "ƒ"    },
  { code: "ARS", name: "Argentine Peso",                 symbol: "$"    },
  { code: "AUD", name: "Australian Dollar",              symbol: "A$"   },
  { code: "AWG", name: "Aruban Florin",                  symbol: "ƒ"    },
  { code: "BBD", name: "Barbadian Dollar",               symbol: "Bds$" },
  { code: "BDT", name: "Bangladeshi Taka",               symbol: "৳"    },
  { code: "BGN", name: "Bulgarian Lev",                  symbol: "лв"   },
  { code: "BHD", name: "Bahraini Dinar",                 symbol: "BD"   },
  { code: "BRL", name: "Brazilian Real",                 symbol: "R$"   },
  { code: "BWP", name: "Botswanan Pula",                 symbol: "P"    },
  { code: "BZD", name: "Belize Dollar",                  symbol: "BZ$"  },
  { code: "CAD", name: "Canadian Dollar",                symbol: "CA$"  },
  { code: "CHF", name: "Swiss Franc",                    symbol: "Fr"   },
  { code: "CLP", name: "Chilean Peso",                   symbol: "$"    },
  { code: "CNY", name: "Chinese Yuan",                   symbol: "¥"    },
  { code: "COP", name: "Colombian Peso",                 symbol: "$"    },
  { code: "CRC", name: "Costa Rican Colón",              symbol: "₡"    },
  { code: "CZK", name: "Czech Koruna",                   symbol: "Kč"   },
  { code: "DKK", name: "Danish Krone",                   symbol: "kr"   },
  { code: "DOP", name: "Dominican Peso",                 symbol: "RD$"  },
  { code: "EGP", name: "Egyptian Pound",                 symbol: "£"    },
  { code: "ETB", name: "Ethiopian Birr",                 symbol: "Br"   },
  { code: "EUR", name: "Euro",                           symbol: "€"    },
  { code: "GBP", name: "British Pound",                  symbol: "£"    },
  { code: "GHS", name: "Ghanaian Cedi",                  symbol: "₵"    },
  { code: "GTQ", name: "Guatemalan Quetzal",             symbol: "Q"    },
  { code: "GYD", name: "Guyanese Dollar",                symbol: "G$"   },
  { code: "HKD", name: "Hong Kong Dollar",               symbol: "HK$"  },
  { code: "HNL", name: "Honduran Lempira",               symbol: "L"    },
  { code: "HRK", name: "Croatian Kuna",                  symbol: "kn"   },
  { code: "HUF", name: "Hungarian Forint",               symbol: "Ft"   },
  { code: "IDR", name: "Indonesian Rupiah",              symbol: "Rp"   },
  { code: "ILS", name: "Israeli New Shekel",             symbol: "₪"    },
  { code: "INR", name: "Indian Rupee",                   symbol: "₹"    },
  { code: "ISK", name: "Icelandic Krona",                symbol: "kr"   },
  { code: "JMD", name: "Jamaican Dollar",                symbol: "J$"   },
  { code: "JOD", name: "Jordanian Dinar",                symbol: "JD"   },
  { code: "JPY", name: "Japanese Yen",                   symbol: "¥"    },
  { code: "KES", name: "Kenyan Shilling",                symbol: "KSh"  },
  { code: "KRW", name: "South Korean Won",               symbol: "₩"    },
  { code: "KWD", name: "Kuwaiti Dinar",                  symbol: "د.ك"  },
  { code: "LKR", name: "Sri Lankan Rupee",               symbol: "₨"    },
  { code: "MAD", name: "Moroccan Dirham",                symbol: "د.م." },
  { code: "MMK", name: "Myanmar Kyat",                   symbol: "K"    },
  { code: "MUR", name: "Mauritian Rupee",                symbol: "₨"    },
  { code: "MXN", name: "Mexican Peso",                   symbol: "$"    },
  { code: "MYR", name: "Malaysian Ringgit",              symbol: "RM"   },
  { code: "MZN", name: "Mozambican Metical",             symbol: "MT"   },
  { code: "NGN", name: "Nigerian Naira",                 symbol: "₦"    },
  { code: "NIO", name: "Nicaraguan Córdoba",             symbol: "C$"   },
  { code: "NOK", name: "Norwegian Krone",                symbol: "kr"   },
  { code: "NPR", name: "Nepalese Rupee",                 symbol: "₨"    },
  { code: "NZD", name: "New Zealand Dollar",             symbol: "NZ$"  },
  { code: "OMR", name: "Omani Rial",                     symbol: "﷼"    },
  { code: "PEN", name: "Peruvian Sol",                   symbol: "S/"   },
  { code: "PHP", name: "Philippine Peso",                symbol: "₱"    },
  { code: "PKR", name: "Pakistani Rupee",                symbol: "₨"    },
  { code: "PLN", name: "Polish Zloty",                   symbol: "zł"   },
  { code: "QAR", name: "Qatari Riyal",                   symbol: "﷼"    },
  { code: "RON", name: "Romanian Leu",                   symbol: "lei"  },
  { code: "RUB", name: "Russian Ruble",                  symbol: "₽"    },
  { code: "RWF", name: "Rwandan Franc",                  symbol: "Fr"   },
  { code: "SAR", name: "Saudi Riyal",                    symbol: "﷼"    },
  { code: "SEK", name: "Swedish Krona",                  symbol: "kr"   },
  { code: "SGD", name: "Singapore Dollar",               symbol: "S$"   },
  { code: "SRD", name: "Surinamese Dollar",              symbol: "SR$"  },
  { code: "THB", name: "Thai Baht",                      symbol: "฿"    },
  { code: "TND", name: "Tunisian Dinar",                 symbol: "DT"   },
  { code: "TRY", name: "Turkish Lira",                   symbol: "₺"    },
  { code: "TTD", name: "Trinidad and Tobago Dollar",     symbol: "TT$"  },
  { code: "TWD", name: "Taiwan Dollar",                  symbol: "NT$"  },
  { code: "TZS", name: "Tanzanian Shilling",             symbol: "TSh"  },
  { code: "UGX", name: "Ugandan Shilling",               symbol: "USh"  },
  { code: "USD", name: "US Dollar",                      symbol: "$"    },
  { code: "UYU", name: "Uruguayan Peso",                 symbol: "$U"   },
  { code: "VES", name: "Venezuelan Bolívar",             symbol: "Bs.S" },
  { code: "VND", name: "Vietnamese Dong",                symbol: "₫"    },
  { code: "XAF", name: "Central African CFA Franc",      symbol: "Fr"   },
  { code: "XCD", name: "East Caribbean Dollar",          symbol: "EC$"  },
  { code: "XOF", name: "West African CFA Franc",         symbol: "Fr"   },
  { code: "ZAR", name: "South African Rand",             symbol: "R"    },
  { code: "ZMW", name: "Zambian Kwacha",                 symbol: "ZK"   },
];